var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"column\" flex=\"flex\" layout-fill=\"layout-fill\" layout-padding=\"layout-padding\"><div layout=\"row\" class=\"itemCardHeader\"><div><h4>Events</h4></div><div flex=\"flex\"></div><div><h4><a href=\"\" ng-click=\"vm.addContract()\"><span class=\"glyphicon glyphicon-plus\"></span></a></h4></div></div><!--md-button(ng-click=\"vm.addContract()\") Add Contract--><div ng-repeat=\"contract in vm.contractsList\" ng-hide=\"contract.status == 'abandoned'\" class=\"itemCard\"><div class=\"pull-right\"><md-button ng-click=\"vm.goToContract(contract)\" aria-label=\"close\">View Contract</md-button></div><div class=\"md-title\">{{::contract.eventName}}</div><div>{{::contract.eventDate  | date:'fullDate' }}</div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/customers/customers/tabs/contract-history.jade
// module id = 255
// module chunks = 0